interface ShadowsProps {
    name: string;
    value: string;
}

const shadows: ShadowsProps[] = [
    {
        name: 'level1-soft',
        value: 'var(--shadow-level1-soft, 0 1px 4px 0 rgba(0, 0, 0, 0.2))',
    },
    {
        name: 'level2-soft',
        value: 'var(--shadow-level2-soft, 0 2px 8px 0 rgba(0, 0, 0, 0.2))',
    },
    {
        name: 'level3-soft',
        value: 'var(--shadow-level3-soft, 0 4px 10px 0 rgba(0, 0, 0, 0.14))',
    },
    {
        name: 'level4-soft',
        value: 'var(--shadow-level4-soft, 0 8px 16px 0 rgba(0, 0, 0, 0.2))',
    },
    {
        name: 'level3-sharp',
        value: 'var(--shadow-level3-sharp, 0 4px 10px 0 rgba(0, 0, 0, 0.2), 0 0 1px 0 rgba(0, 0, 0, 0.3))',
    },
    {
        name: 'drop-level1-soft',
        value: 'var(--drop-shadow-level1-soft, 0 0 7px black)',
    },
];

export default shadows;
